import { Tabs } from "@mantine/core";
import { withTranslation } from "react-i18next";
import EmploymentHistory from "./EmploymentHistory";
import Links from "./Links";
import ProfileInformation from "./ProfileInformation";
import profile from "../../assets/profile.png";
import EHistory from "../../assets/EmploymentHistory.png";
import education from "../../assets/Education.png";
import Document from "../../assets/Document.png";
import skill from "../../assets/skill.png";
import link from "../../assets/Link.png";
import video from "../../assets/video.png";
import Button from "../../components/Button";
import "./styles.css";
import Page from "../../components/Page";
import { useEffect, useState } from "react";
import { backendUrl } from "../../constants";
import SkillsMore from "./Skills&More";
import Education from "./Education";
import Documents from "./Documents";
import ProfileVideo from "./ProfileVideo";
import { showNotification } from "@mantine/notifications";

const Index = () => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [profileData, setProfileData] = useState({
    salaryRange: "hourly",
    relocate: false,
    phoneShowConnections: true,
  });
  const [links, setLinks] = useState({ userId: createdBy.id, weblinks: [] });
  const [defaultLinks, setDefaultLinks] = useState({});
  const [skills, setSkills] = useState({ userId: createdBy.id });
  const [isLoading, setIsLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [tab, setTab] = useState("1");
  const [educationData, setEducationData] = useState([]);
  const [employmentData, setEmployementData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [profileVideo, setProfileVideo] = useState({ userId: createdBy.id });

  //JobSeekerInfo
  useEffect(() => {
    setIsLoading(true);
    setEducationData([]);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}user/getJobSeekerDetails/${createdBy.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        setProfileData({
          firstName: response.data[0]?.firstName,
          lastName: response.data[0]?.lastName,
          email: response.data[0]?.email,
          jobSeekerProfileImage:
            response.data[0]?.jobSeeker[0]?.jobSeekerProfileImage,
          jobTitle: response.data[0]?.jobSeeker[0]?.jobTitle,
          maxSalary: response.data[0]?.jobSeeker[0]?.maxSalary,
          minSalary: response.data[0]?.jobSeeker[0]?.minSalary,
          summary: response.data[0]?.jobSeeker[0]?.summary,
          zipCode: response.data[0]?.zipCode,
          phoneNo: response.data[0]?.phoneNo,
          relocate: response.data[0]?.jobSeeker[0]?.relocate,
          employmentPreferences:
            response.data[0]?.jobSeeker[0]?.employmentPreferences.map(
              (a) => a.preferenceType?._id
            ),
          employmentStatus:
            response.data[0]?.jobSeeker[0]?.employmentStatus?._id,
          jobSeekerIndustry:
            response.data[0].jobSeeker[0].jobSeekerIndustry.map(
              (a) => a.industry?._id
            ),
        });

        // Education
        response.data[0]?.jobSeeker[0]?.jobSeekerEducation.map((e) => {
          setEducationData((edu) => [
            ...edu,
            {
              major: e?.major?.majorName,
              GPA: e?.GPA,
              school: e?.school?.lookupName,
              state: e?.state?.lookupName,
              id: e._id,
              data: e,
            },
          ]);
        });

        //skills&More
        let jobSeekerInterets = [];
        let skills = [];
        let jobSeekerLanguages = [];
        response.data[0]?.jobSeeker[0]?.jobSeekerInterets[0]?.interest.map(
          (e) => {
            jobSeekerInterets.push(e.interest?._id);
          }
        );
        response.data[0]?.jobSeeker[0]?.jobSeekerSkills[0]?.skills.map((e) => {
          skills.push(e.skills?._id);
        });
        response.data[0]?.jobSeeker[0]?.jobSeekerLanguages[0]?.language.map(
          (e) => {
            jobSeekerLanguages.push(e.language?._id);
          }
        );
        setSkills((v) => ({
          ...v,
          jobSeekerInterets: jobSeekerInterets,
          skills: skills,
          jobSeekerLanguages: jobSeekerLanguages,
          skillPrivacyLevel:
            response.data[0]?.jobSeeker[0]?.jobSeekerSkills[0]?.privacyLevel
              ?._id,
          interestPrivacyLevel:
            response.data[0]?.jobSeeker[0]?.jobSeekerInterets[0]?.privacyLevel
              ?._id,
          languagePrivacyLevel:
            response.data[0]?.jobSeeker[0]?.jobSeekerLanguages[0]?.privacyLevel
              ?._id,
        }));

        //Employment
        setEmployementData([]);
        response.data[0]?.jobSeeker[0]?.jobSeekerEmploymentHistory.map((e) => {
          setEmployementData((edu) => [
            ...edu,
            {
              employeer: e.employeer?.firstName,
              jobTitle: e.jobTitle,
              startDate: e.startDate,
              endDate: e.endDate,
              id: e._id,
              data: e,
            },
          ]);
        });

        setDocumentData([]);
        response.data[0]?.jobSeeker[0]?.jobSeekerDocuments.map((e) => {
          setDocumentData((edu) => [
            ...edu,
            {
              documentType: e.documentType?.lookupName,
              documentName: e.documentName,
              document: e.document,
              id: e._id,
              data: e,
            },
          ]);
        });

        //Profile Video
        setProfileVideo({
          profileVideo:
            response.data[0]?.jobSeeker[0]?.jobSeekerProfileVideo[0]
              .profileVideo,
          privacyLevel:
            response.data[0]?.jobSeeker[0]?.jobSeekerProfileVideo[0]
              ?.privacyLevel?._id,
        });

        //links
        response.data[0]?.jobSeeker[0]?.jobSeekerWebLinks.map((obj) => {
          let aLink = { linkType: obj?.linkType?._id, linkURL: obj?.linkURL };
          setLinks((a) => ({
            ...a,
            weblinks: [...a.weblinks, aLink],
          }));
          setDefaultLinks((v) => ({
            ...v,
            [obj.linkType?.lookupName]: obj.linkURL,
          }));
        });

        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  }, [createdBy.id, refetch]);

  //save profile data
  const handleSaveProfile = () => {
    setIsLoading(true);
    //profileInformation data
    if (tab === "1") {
      let formData = new FormData();
      Object.keys(profileData).forEach((key) => {
        if (key === "jobSeekerProfileImage") {
          profileData[key].name && formData.append(key, profileData[key]);
        } else formData.append(key, profileData[key]);
      });
      formData.append("userId", createdBy.id);
      const options2 = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
        },
        body: formData,
      };
      fetch(`${backendUrl}user/saveJobSeekerProfileInfo`, options2)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    } else if (tab === "4") {
      let newData = {
        interestPrivacyLevel: skills.interestPrivacyLevel,
        jobSeekerInterets: skills.jobSeekerInterets.join(","),
        jobSeekerLanguages: skills.jobSeekerLanguages.join(","),
        languagePrivacyLevel: skills.languagePrivacyLevel,
        skillPrivacyLevel: skills.skillPrivacyLevel,
        skills: skills.skills.join(","),
        userId: createdBy.id,
      };
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(newData),
      };
      fetch(`${backendUrl}user/saveJobSeekerSkills`, options)
        .then((response) => response.json())
        .then((response) => {})
        .catch((err) => console.error(err));
    } else if (tab === "5") {
      let formData = new FormData();
      formData.append("userId", createdBy.id);
      Object.keys(profileVideo).forEach((key) =>
        formData.append(key, profileVideo[key])
      );
      const options = {
        method: "POST",
        headers: {
          Accept: "application/form-data",
        },
        body: formData,
      };
      fetch(`${backendUrl}user/saveJobSeekerProfileVideo`, options)
        .then((response) => response.json())
        .then((response) => {})
        .catch((err) => console.error(err));
    } else if (tab === "7") {
      const options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(links),
      };
      fetch(`${backendUrl}user/saveJobSeekerWebLinks`, options)
        .then((response) => response.json())
        .then((response) => {
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    }
    showNotification({
      message: "Profile Information Saved Successfully",
      color: "green",
    });
  };
  const handleNext = () => {
    if (tab === "1") {
      if (profileData.firstName.length < 1 || profileData.lastName.length < 1) {
        console.log("jjhhjjhkh", profileData);
        showNotification({ message: "Please Enter Full Name", color: "red" });
      } else {
        handleSaveProfile();
        setTab((parseInt(tab) + 1).toString());
      }
    } else if (tab === "4") {
      if (
        !skills.skills[0] ||
        !skills.jobSeekerLanguages[0] ||
        !skills.jobSeekerInterets[0]
      ) {
        let message = !skills.skills[0]
          ? "Skills"
          : !skills.jobSeekerLanguages[0]
          ? "languages"
          : "Interests";
        showNotification({
          message: `Please select ${message}.`,
          color: "red",
        });
      } else {
        handleSaveProfile();
        setTab((parseInt(tab) + 1).toString());
      }
    } else {
      handleSaveProfile();
      if (tab === "7") {
      } else {
        setTab((parseInt(tab) + 1).toString());
      }
    }
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <Tabs
        defaultValue={tab}
        // variant="pills"
        color="red.9"
        value={tab}
        onTabChange={setTab}
      >
        <Tabs.List position="center" grow>
          <Tabs.Tab value="1" icon={<img src={profile} width="30px" />}>
            1. Profile Information
          </Tabs.Tab>
          <Tabs.Tab value="2" icon={<img src={EHistory} width="30px" />}>
            2. Employment History
          </Tabs.Tab>
          <Tabs.Tab value="3" icon={<img src={education} width="30px" />}>
            3. Education
          </Tabs.Tab>
          <Tabs.Tab value="4" icon={<img src={skill} width="30px" />}>
            4. Skills & More
          </Tabs.Tab>
          <Tabs.Tab value="5" icon={<img src={video} width="30px" />}>
            5. Profile Video
          </Tabs.Tab>
          <Tabs.Tab value="6" icon={<img src={Document} width="30px" />}>
            6. Documents
          </Tabs.Tab>
          <Tabs.Tab value="7" icon={<img src={link} width="30px" />}>
            7. Web Links
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="1" pt="xs">
          <ProfileInformation
            profileData={profileData}
            setProfileData={setProfileData}
          />
        </Tabs.Panel>
        <Tabs.Panel value="4" pt="xs">
          <SkillsMore skillsData={skills} setSkillsData={setSkills} />
        </Tabs.Panel>
        <Tabs.Panel value="3" pt="xs">
          <Education educationInfo={educationData} setRefetch={setRefetch} />
        </Tabs.Panel>
        <Tabs.Panel value="2" pt="xs">
          <EmploymentHistory
            employmentData={employmentData}
            setRefetch={setRefetch}
          />
        </Tabs.Panel>
        <Tabs.Panel value="5" pt="xs">
          <ProfileVideo
            profileVideo={profileVideo}
            setProfileVideo={setProfileVideo}
          />
        </Tabs.Panel>
        <Tabs.Panel value="6" pt="xs">
          <Documents documentData={documentData} setRefetch={setRefetch} />
        </Tabs.Panel>
        <Tabs.Panel value="7" pt="xs">
          <Links
            links={links}
            setLinks={setLinks}
            defaultLinks={defaultLinks}
          />
        </Tabs.Panel>

        <div className="pro-button">
          {tab !== "1" && (
            <Button
              title="Back"
              width="300px"
              onClick={() => setTab((parseInt(tab) - 1).toString())}
            />
          )}
          {tab === "7" ? (
            <Button
              title="Save & Finish"
              primary={true}
              width="300px"
              onClick={handleSaveProfile}
            />
          ) : (
            <Button
              title={tab === "7" ? "Finish" : "Save & Next"}
              primary={true}
              width="300px"
              onClick={handleNext}
            />
          )}
        </div>
      </Tabs>
    </Page>
  );
};
export default withTranslation()(Index);
